import React from 'react';
import { TabPanel } from '../TabPanel';

export interface IVariableTabProps<T> {
  label: (data: T) => string | JSX.Element;
  uri?: (data: T) => string;
  onClose?: (data: T) => void;
  children?: any;

  data: T[];
  render: (data: T) => JSX.Element;
  keyExtractor: (data: T) => string;

  value?: string; // will be injected in RouteTabs Component.
  index?: string; // will be injected in RouteTabs Component.
}

const VariableTab = <T,>(props: IVariableTabProps<T>): JSX.Element => {
  const { value, index } = props;

  return (
    <TabPanel value={value} index={index}>
      {props.children}
    </TabPanel>
  );
};

VariableTab.displayName = 'VariableTab';

export default VariableTab;
